module.exports = __webpack_public_path__ + "static/img/load.6a9b24c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/load.jpg
// module id = 2W0m
// module chunks = 1